import React, { forwardRef } from 'react';

const IcWarningWhiteBorder = forwardRef((properties, ref) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  ref,
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M19.4605 23.2499H4.53784C1.09043 23.2499 -1.07664 19.5324 0.622069 16.5325L8.08341 3.35612C9.80685 0.312602 14.1915 0.312615 15.915 3.35612L23.3763 16.5325C25.075 19.5324 22.9079 23.2499 19.4605 23.2499Z",
  fill: "white",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M9.82473 4.34161C10.7822 2.65077 13.2181 2.65078 14.1756 4.34162L21.6369 17.518C22.5807 19.1846 21.3767 21.2499 19.4615 21.2499H4.53882C2.62359 21.2499 1.41966 19.1846 2.36339 17.518L9.82473 4.34161Z",
  fill: "var(--warning-icon-default)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M11 13.75L11 9.5C11 8.94772 11.4477 8.5 12 8.5C12.5523 8.5 13 8.94772 13 9.5L13 13.75C13 14.3023 12.5523 14.75 12 14.75C11.4477 14.75 11 14.3023 11 13.75Z",
  fill: "var(--info-icon-in-default)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: "12",
  cy: "17.25",
  fill: "var(--info-icon-in-default)",
  r: "1.25"
})));

export { IcWarningWhiteBorder };
//# sourceMappingURL=ic-warning-white-border.js.map
